class SiteActionShareUrl
    extends SiteAction {

    private readonly _action: IActionTypeShareUrl;
    private readonly _card: ISiteCard;

    constructor(card: ISiteCard, action: IActionTypeShareUrl, next: SiteAction | null) {
        super(next);
        this._action = action;
        this._card = card;
    }
    async _execute() {
        // Share or copy to clipboard
        if (navigator.share) {
            navigator.share({
                title: this._action.title,
                text: this._action.text,
                url: this._action.url
            });
        } else if(navigator.clipboard) {
            var site = Site.getSite();

            site.addMessage(new SiteMessage({
                sort: "Info",
                message: site.Config.strings["copied to clipboard."]
            }));
            navigator.clipboard.writeText(this._action.url);
        }
        return true;
    }
}